module.exports = __webpack_public_path__ + "static/media/Coming Soon Background.f76fd7da.png";